import useSSE from "../../hooks/useSSE";

// DO NOT use this hook directly in components or other hooks
// this is an internal hook that should be only used by MeetingDetailsProvider, to provide centralized state management and logic control
export default function useMeetingDetailsSSE({ meetingDetailsEventSourceRef, meeting, store, sendCurrentUserEvent, currentUserAuthData }) {
  useSSE(meetingDetailsEventSourceRef, meeting && `/lw/${meeting.mid}/sse`, {
    "status-changed": ({ status }) => {
      console.log("MSSE: status-changed", { status });
      store.meeting !== null && store.updateMeetingStatus(status);
      if (status === "ending") {
        // TODO: remove once the janus-leave will work natively
        const currUserPid = store?.participants && store.participants.find((participant) => participant.user.uid === currentUserAuthData.uid)?.pid;
        sendCurrentUserEvent({ lwid: store.meeting?.mid, pid: currUserPid, data: { status: "leaving" } });
      }
    },
    updated: (workspace) => {
      console.log("MSSE: updated", workspace);
      store.meeting !== null && store.updateMeetingWorkspace(workspace);
    },
    // Additional SSE event handlers can be added here as needed
  });
}
